export const getInterfaceAndDatatype = (dataType) => {
    switch (dataType) {
      case "Single Line Text":
        return { dataType: "varchar(255)", interface: "input" };
      case "Multi Line Text":
        return { dataType: "varchar(1024)", interface: "text-area" };
      // case "Dropdown":
      //   return { dataType: "varchar(1024)", interface: "repeater-fields" };
      case "Timestamp":
        return { dataType: "TIMESTAMP(3) DEFAULT CURRENT_TIMESTAMP", interface: "datetime" };    
      case "File":
        return { dataType: "varchar(1024)", interface: "file" };
      case "Image":
        return { dataType: "varchar(1024)", interface: "image" };
      case "boolean":
        return { dataType: "boolean", interface: "boolean" };
      case "One-to-Many":
        return { dataType: "varchar(255)", interface: "select" };
      case "Number":
        return { dataType: "Integer", interface: "floatNumber" };
      case "Json":
        return { dataType: "Json", interface: "Json" };
      default:
        return { dataType: "varchar(255)", interface: "input" };
    }
  };
  